export default __webpack_public_path__ + "static/media/vitalik_poap_4.44fae06c.svg";